import React, { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { RealtimeChat } from "@/utils/RealtimeAudio";
import { useAuth } from "@/context/AuthContext";
interface VoiceInterfaceProps {
  onSpeakingChange?: (speaking: boolean) => void;
}

const VoiceInterface: React.FC<VoiceInterfaceProps> = ({ onSpeakingChange }) => {
  const { toast } = useToast();
  const [isConnected, setIsConnected] = useState(false);
  const chatRef = useRef<RealtimeChat | null>(null);
  const { isAuthenticated } = useAuth();
  const handleMessage = (event: any) => {
    // Optional: inspect event types (response.created, response.audio.*)
    if (event?.type === "response.audio.delta") {
      onSpeakingChange?.(true);
    } else if (event?.type === "response.audio.done") {
      onSpeakingChange?.(false);
    }
  };

  const startConversation = async () => {
    try {
      // Ask for mic permission upfront for better UX
      await navigator.mediaDevices.getUserMedia({ audio: true });

      const chat = new RealtimeChat(handleMessage);
      chatRef.current = chat;
      await chat.init();
      setIsConnected(true);
      toast({ title: "Voice Concierge Ready", description: "You can talk to Noche Loco now." });
    } catch (error) {
      console.error("Error starting conversation:", error);
      toast({
        title: "Voice Error",
        description: error instanceof Error ? error.message : "Failed to start",
        variant: "destructive",
      });
    }
  };

  const endConversation = () => {
    chatRef.current?.disconnect();
    setIsConnected(false);
    onSpeakingChange?.(false);
  };

useEffect(() => {
    return () => chatRef.current?.disconnect();
  }, []);

  if (!isAuthenticated) return null;
  return (
    <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-40 flex flex-col items-center gap-3">
      {!isConnected ? (
        <Button onClick={startConversation} className="px-5">
          Start Voice Concierge
        </Button>
      ) : (
        <div className="flex items-center gap-3">
          <Button variant="secondary" onClick={endConversation}>End</Button>
          <Button
            onClick={() => {
              const text = prompt("Say or type a message to the concierge:")?.trim();
              if (text) chatRef.current?.sendMessage(text);
            }}
            variant="outline"
          >
            Send Text
          </Button>
        </div>
      )}
    </div>
  );
};

export default VoiceInterface;
